function csvCell(value) {
  let text = String(value ?? "");
  // Evitar fórmulas al abrir un CSV externo en Excel. El importador reconoce
  // esta comilla de protección en los códigos del respaldo.
  if (typeof value === "string" && /^[\s]*[=+@-]/.test(text)) text = `'${text}`;
  return `"${text.replace(/"/g, '""')}"`;
}

export function priceImportCsv(rows = [], { backup = false } = {}) {
  const lines = backup
    ? [
        ["codigo", "precio"],
        ...rows.filter((row) => row.status === "updated").map((row) => [row.code, row.matchType === "variant" && row.previousRawPrice === null ? "HEREDAR" : row.previousRawPrice]),
      ]
    : [
        ["fila", "codigo", "producto", "variante", "estado", "precio_anterior", "precio_nuevo", "diferencia", "mensaje"],
        ...rows.map((row) => [row.row, row.code, row.name, row.variant, row.status, row.previousPrice, row.newPrice, row.difference, row.message]),
      ];
  return lines.map((line) => line.map(csvCell).join(";")).join("\r\n");
}

export function downloadPriceImportFile(content, name) {
  const url = URL.createObjectURL(new Blob(["\uFEFF", content], { type: "text/csv;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
